import { StateScheme } from 'app/providers/StoreProvider/config/StateScheme'

export const getChartCountyData = (state: StateScheme) => {
    return state.finance.chartCountryData
}
